"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const DeleteOutline_1 = __importDefault(require("@material-ui/icons/DeleteOutline"));
const button_1 = __importDefault(require("../material-button/button"));
const no_theme_tooltip_1 = __importDefault(require("../tooltip/no-theme-tooltip"));
const duplicate_icon_1 = __importDefault(require("./icons/duplicate-icon"));
const move_icon_1 = __importDefault(require("./icons/move-icon"));
require("../../styles/components/grid-layout/card-controls.less");
const CardControls = ({ disableAddCards = false, cardId, onDeleteCard, onDuplicateCard }) => {
    const handleDuplicateClick = (0, react_1.useCallback)(() => {
        onDuplicateCard(cardId);
    }, [cardId, onDuplicateCard]);
    const handleDeleteClick = (0, react_1.useCallback)(() => {
        onDeleteCard(cardId);
    }, [cardId, onDeleteCard]);
    return (react_1.default.createElement("div", { className: "card-controls" },
        react_1.default.createElement(button_1.default, { className: "control-button" },
            react_1.default.createElement(no_theme_tooltip_1.default, { title: "Move" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(move_icon_1.default, { className: "move-icon" })))),
        react_1.default.createElement(button_1.default, { className: "control-button", onClick: handleDuplicateClick, disabled: disableAddCards },
            react_1.default.createElement(no_theme_tooltip_1.default, { title: "Duplicate" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(duplicate_icon_1.default, { className: "duplicate-icon" })))),
        react_1.default.createElement(button_1.default, { className: "control-button", onClick: handleDeleteClick },
            react_1.default.createElement(no_theme_tooltip_1.default, { title: "Delete" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(DeleteOutline_1.default, null))))));
};
exports.default = CardControls;
//# sourceMappingURL=card-controls.js.map